import React from "react";
import { Link } from "react-router-dom";

import blogTopics from "../../data/blogTopics";

import SectionContainer from "../common/SectionContainer";
import SectionTitle from "../common/SectionTitle";

import BlogCard from "../cards/BlogCard";

function BlogPreview() {
  const featuredBlogs =
    blogTopics.filter(
      (blog) => blog.featured
    );

  return (
    <SectionContainer background="#ffffff">
      <SectionTitle
        title="Insights & Growth Resources"
        subtitle="Practical guidance, industry insights and proven frameworks to help businesses make better marketing and growth decisions."
      />

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(340px,1fr))",
          gap: "28px"
        }}
      >
        {featuredBlogs.map((blog) => (
          <BlogCard
            key={blog.slug}
            post={blog}
          />
        ))}
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: "50px"
        }}
      >
        <Link
          to="/blog"
          style={{
            color: "#21b573",
            textDecoration: "none",
            fontWeight: 700
          }}
        >
          Explore All Articles →
        </Link>
      </div>
    </SectionContainer>
  );
}

export default BlogPreview;